const state = {
  menuList: [],
  indexType: '',
};

const mutations = {
  SET_MENULIST: (state, menuList) => {
    state.menuList = menuList;
  },
  SET_INDEX_TYPE: (state, indexType) => {
    state.indexType = indexType;
  },
};

const actions = {
  setMenuList({ commit }, menuList) {
    commit('SET_MENULIST', menuList);
  },
  setIndexType({ commit }, indexType) {
    commit('SET_INDEX_TYPE', indexType);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
